import React, {PropsWithChildren} from 'react';
import {CookieProvider, CookieProviderProps} from './cookie/CookieContext';
import {LocalStorageProvider} from './localStorage/LocalStorageContext';
import {SessionStorageProvider} from './sessionStorage/SesionStorageContext';
import {useUpdateConsentBannerAcceptedState} from './utils/consentBannerAcceptedState';

export type StorageState = CookieProviderProps;

export function StorageProvider({
  serverCookies,
  browserCookies,
  defaultCookieDomain,
  children,
}: PropsWithChildren<StorageState>) {
  useUpdateConsentBannerAcceptedState();

  return (
    <CookieProvider
      serverCookies={serverCookies}
      browserCookies={browserCookies}
      defaultCookieDomain={defaultCookieDomain}
    >
      <LocalStorageProvider>
        <SessionStorageProvider>{children}</SessionStorageProvider>
      </LocalStorageProvider>
    </CookieProvider>
  );
}
